import { useRouter } from 'next/router'
import { PluginDebug } from '../plugins/VoterWeightPlugins/lib/PluginDebug'
import React from 'react'

const PageBodyContainer = ({ children }) => {
  const { pathname, query } = useRouter()

  // TODO TEMP DEBUG - REMOVE BEFORE MERGE
  if (query['debug'] !== undefined) {
    return <PluginDebug />
  }

  return (
    <>
      <div className={`grid gap-4 pt-4 min-h-[calc(100vh_-_80px)] pb-12`}>
        <div className="relative z-[2] px-4 md:px-8 xl:px-4">{children}</div>
      </div>
    </>
  )
}

export default PageBodyContainer
